export default {"src":"/_next/static/media/STX.6fdfa210.svg","height":18,"width":18};